var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.PasswordEntry,{staticClass:"mb-28",attrs:{"passwordStatus":{ incorrect: false },"getEnvelope":() => {}}}),_c(_setup.PasswordEntry,{staticClass:"mb-28",attrs:{"passwordStatus":{ incorrect: true },"getEnvelope":() => {}}}),_c(_setup.PasswordEntry,{attrs:{"passwordStatus":{ incorrect: false },"getEnvelope":() => {},"branding":{
      colours: {
        primary: '#f012be',
        primaryIsWhite: false,
        accentPrimary: '#7E10C1',
        accentSecondary: '#ffffff'
      },
      logo: _setup.logoWide,
      customisedBranding: true
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }